// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimOtherCredit from '@deere/cps-it.warranty-model-factory/lib/claim-item-other-credit';
import FormattedNumberInput from '../../../../shared/components/formatted-number-input';
import KeyValueDropDown from '../claim-fields/key-value-dropdown';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {getOtherCreditTypes} from '../../../shared/services/claim-shared-helper';
import {translate} from '../../../../shared/services/translation-service';

const isDetailsSelected = details => details !== '';

// isTravelSelected: returns true for other credit types which should allow 'distance' rather than 'amount' input enabled

const isTravelSelected = details => (details === '05') || (details === '06') || (details === '11');

const amountDisabled = credit => !isDetailsSelected(credit.details.key) || isTravelSelected(credit.details.key);
const distanceDisabled = credit => !isDetailsSelected(credit.details.key) || !isTravelSelected(credit.details.key);

function handleDescriptionChange(event) {

    this.onDescriptionChange(event.target.value, this.otherCreditDescriptions);

    isTravelSelected(event.target.value) ?
        this.onAmountChange(0) :
        this.onDistanceChange(0);

}

function handleAmountChange(amount) {

    this.onAmountChange(amount);

}

function handleDistanceChange(distance) {

    this.onDistanceChange(distance);

}

function handleCommentsChange(event) {

    this.onCommentsChange(event.target.value);

}

const OtherCreditsPanelRowBody = props =>
    <div>
        <section className={`other-credits-panel-row-body credit-item-${props.credit.lineNumber} ${props.highlightClass}`}>
            <KeyValueDropDown
                className='description'
                list={getOtherCreditTypes(props.otherCreditDescriptions, props.credit.details)}
                onChange={props::handleDescriptionChange}
                value={props.credit.details.key}
            />
            <FormattedNumberInput
                allowNegative={false}
                className='amount'
                decimalPrecision={2}
                disabled={amountDisabled(props.credit)}
                isValidInput={value => value < 10000000}
                onValueChange={props::handleAmountChange}
                value={props.credit.amount}
            />
            <FormattedNumberInput
                allowNegative={false}
                className='distance'
                decimalPrecision={2}
                disabled={distanceDisabled(props.credit)}
                isValidInput={value => value < 10000}
                onValueChange={props::handleDistanceChange}
                value={props.credit.distance}
            />
            <input
                className='comments'
                onChange={props::handleCommentsChange}
                type='text'
                value={props.credit.comments}
            />
            <span className='delete-icon-button'>
                <button
                    className='icon-trash-can'
                    onClick={props.onDelete}
                />
            </span>
        </section>
        {
            props.vsrMessage && <span className='vsr-message'>{`${props.vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}</span>
        }
    </div>;

OtherCreditsPanelRowBody.displayName = 'OtherCreditsPanelRowBody';
OtherCreditsPanelRowBody.propTypes = {
    credit: PropTypes.instanceOf(ClaimOtherCredit).isRequired,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    onAmountChange: PropTypes.func.isRequired,
    onCommentsChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onDescriptionChange: PropTypes.func.isRequired,
    onDistanceChange: PropTypes.func.isRequired,
    otherCreditDescriptions: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    vsrMessage: PropTypes.string
};

export default OtherCreditsPanelRowBody;



// WEBPACK FOOTER //
// ./src/claim/shared/components/other-credits-panel/other-credits-panel-row-body.js